// Base Url
export const BASE_URL = process.env.REACT_APP_BASE_URL

// Wordpress
export const WORDPRESS_STYLES_SINGLE = process.env.REACT_APP_WORDPRESS_STYLES_SINGLE
export const WORDPRESS_ANNOUNCEMENTS = process.env.REACT_APP_WORDPRESS_ANNOUNCEMENTS
